import React from 'react';
import Icon from '../../../components/AppIcon';
import { useLanguage } from '../../../i18n/LanguageContext';

const AnalyticsCard = ({ 
  title, 
  value, 
  change, 
  changeType, 
  icon, 
  iconColor,
  subtitle,
  onClick
}) => {
  const { t } = useLanguage();
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-destructive';
    return 'text-muted-foreground';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div
      className={`analytics-card bg-card border border-border rounded-lg p-4 md:p-6 shadow-warm hover:shadow-warm-md transition-smooth ${onClick ? 'cursor-pointer hover:border-primary/40' : ''}`}
      onClick={onClick}
    >
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="flex-1">
          <p className="text-xs md:text-sm font-caption text-muted-foreground mb-1">
            {title}
          </p>
          <h3 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground">
            {value}
          </h3>
          {subtitle && (
            <p className="text-xs md:text-sm font-caption text-muted-foreground mt-1">
              {subtitle}
            </p>
          )}
        </div>
        <div 
          className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center"
          style={{ backgroundColor: `${iconColor}15` }}
        >
          <Icon 
            name={icon} 
            size={20} 
            color={iconColor} 
          />
        </div>
      </div>

      {change && (
        <div className="flex items-center gap-2">
          <span className={`inline-flex items-center gap-1 text-xs md:text-sm font-data font-medium ${getChangeColor()}`}>
            <Icon name={getChangeIcon()} size={16} />
            {change}
          </span>
          <span className="text-xs md:text-sm font-caption text-muted-foreground">
            {t('vsLastMonthLabel')}
          </span>
        </div>
      )}
    </div>
  );
};

export default AnalyticsCard;